import { padStart } from 'lodash';

export const getUrlParam = (url: string, name: string) => {
    try {
        const urlParams: any = new RegExp('[?|&]' + name + '=([^&;]+?)(&|#|;|$)').exec(url);
        return decodeURIComponent((urlParams[1] || '').replace(/\+/g, '%20'));
    } catch (e) {
        return null;
    }
}

export const checkPassword = (value: string) => {
    const len = value.length; // 长度
    const num = /\d/.test(value); // 匹配数字
    const upperLetter = /[A-Z]/.test(value); // 匹配大写字母
    const lowLetter = /[a-z]/.test(value); // 匹配小写字母
    const corps = /[`~!@#$%^&*()_\-+=<>?:"{}|,./;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/.test(
        value
    ); // 特殊符号
    const reg = Number(num) + Number(upperLetter) + Number(lowLetter) + Number(corps);
    if (len >= 8 && len <= 20 && reg >= 3) {
        return true;
    }
};

// 日期时间补充两位
export const handleNumber = (num: number) => {
    return padStart(num.toString(), 2, '0');
}

// 秒 转换为 日期格式
export const converSecondsToDate = (value: number) => {
    let date = new Date(value * 1000);
    let year = date.getFullYear();
    let month = handleNumber(date.getMonth() + 1);
    let day = handleNumber(date.getDate());
    let hours = handleNumber(date.getHours());
    let minutes = handleNumber(date.getMinutes());
    let senconds = handleNumber(date.getSeconds());
    let result = year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + senconds;
    return result;
}